import styled from 'styled-components';
import { InfoOutlinedIcon } from 'LegacyWeployDesignLanguage/icons';
import Button from 'WeployDesignLanguage/buttons/Button';
import Table from '../common/table';

export const StyledTableCell = styled(Table.Cell)`
  &:nth-child(1) {
    font-size: 16px;
  }

  &:nth-child(3) {
    white-space: nowrap;
  }
`;

export const StyledDialogTitleSubtitle = styled.div`
  ${props => props.theme.typography.body1};
`;

export const StyledDescription = styled.p`
  margin: 0;
  margin-bottom: ${props => props.theme.spacing[3]};
`;

export const StyledUsersContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const StyledName = styled.span`
  font-size: 16px;
`;

export const StyledInlineButton = styled.button`
  font-family: "Assistant", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none;
  border: none;
  background: transparent;
  padding-left: 0;

  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
`;

export const StyledButton = styled(Button)`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

export const StyledRadioButtonsWrapper = styled.div`
  & .MuiFormGroup-root > label {
    margin-left: 0;
    padding: ${props => props.theme.spacing[2]};
    justify-content: space-between;
  }
  & .MuiFormControlLabel-labelPlacementStart {
    margin-right: -8px;
  }
`;

export const StyledRadioLabel = styled.div`
  ${props => props.theme.typography.subtitle1};
`;

export const StyledRadioDescription = styled.div`
  ${props => props.theme.typography.subtitle2};
`;

export const StyledOverflowMenuWrapper = styled.div`
  & .MuiIconButton-root {
    margin: -12px;
  }
`;

export const StyledStatus = styled.span`
  ${props => props.theme.typography.subtitle2};
  color: ${props => props.theme.colors.semantic.warning};
`;

export const StyledContactAdminMessage = styled.div`
  padding-top: ${props => props.theme.spacing[1]};
  padding-right: ${props => props.theme.spacing[3]};
  padding-bottom: ${props => props.theme.spacing[1]};
  grid-area: 2 / 3 / 2 / 3;
  display: grid;
  grid-template-columns: minmax(auto, ${props => props.theme.spacing[4]}) auto;
  grid-template-rows: auto auto;
  ${props => props.theme.typography.subtitle1}
`;

export const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  padding-right: ${props => props.theme.spacing[2]};
  padding-left: ${props => props.theme.spacing[3]};
`;
